module.exports = __webpack_public_path__ + "static/media/signup.a07c8799.jpg";